<div class="row">
  <div class="col-md-6 container">
    <div class="card shadow-sm">
      <div class="card-header">
        <a
          class="btn btn-link text-decoration-none"
          [routerLink]="[
            '/vessels/vessel-information',
            $safeNavigationMigration(versionedVessel?.data?.imo),
          ]"
        >
          Information
        </a>
      </div>
      <div class="card-body">
        <div class="row g-0 bg-body-secondary position-relative">
          <div class="col-md-6 mb-md-0 p-md-4">
            <img
              alt="{{ versionedVessel?.data?.name?.name }}"
              [src]="photo"
              class="w-100"
            />
          </div>
          <div class="col-md-6 p-4 ps-md-0">
            <h5 class="mt-0 fw-semibold">
              IMO: {{ versionedVessel?.data?.imo }}
            </h5>
            <p>Flag: {{ versionedVessel?.data?.name!.flag }}</p>
            <p>
              From:
              {{
                dateTime(
                  $safeNavigationMigration(versionedVessel?.data?.name!.from)
                )
              }}
            </p>
            @if (master) {
              <p>Master: {{ master }}</p>
            }
            @if (versionedVessel && versionedVessel?.data?.active) {
              <p (click)="downloadFile()">
                <i class="fa fa-download" aria-hidden="true"></i>
              </p>
            }
            <input
              type="checkbox"
              class="btn-check"
              id="btn-check-2-outlined"
              [checked]="
                $safeNavigationMigration(versionedVessel?.data?.active)
              "
              (click)="vesselActive()"
              [disabled]="!hasRole('vessel:update')"
            />
            <label
              [ngClass]="{
                'btn-outline-success': $safeNavigationMigration(
                  versionedVessel?.data?.active
                ),
                'btn-outline-secondary': !versionedVessel?.data?.active,
              }"
              class="btn"
              for="btn-check-2-outlined"
              >{{
                versionedVessel?.data?.active ? "Active" : "Inactive"
              }}</label
            >
          </div>
        </div>
      </div>
    </div>

    <div class="card shadow-sm">
      <div class="card-header">
        @if (hasRole("vessel:update")) {
          <a
            class="btn btn-link text-decoration-none"
            [routerLink]="[
              '/vessels/vessel/spec',
              $safeNavigationMigration(versionedVessel?.data?.imo),
            ]"
          >
            Specifications
          </a>
        }
        @if (!hasRole("vessel:update")) {
          <a class="btn btn-link text-decoration-none"> Specifications </a>
        }
        @if (versionedVessel?.data?.spec?.shipParticularId) {
          <a
            (click)="downloadShipParticular(versionedVessel?.data?.spec?.shipParticularId)"
            class="pull-right"
          >
            <i class="fa fa-download" aria-hidden="true"></i>
          </a>
        }
      </div>
      <div class="card-body">
        <div class="row g-2">
          <div class="col-md">
            <div class="form-floating">
              <input
                readonly
                class="form-control-plaintext"
                id="yearBuilt"
                value="{{ versionedVessel?.data?.spec?.yearBuilt }}"
              />
              <label for="yearBuilt">Year Built</label>
            </div>
          </div>
          <div class="col-md">
            <div class="form-floating">
              <input
                readonly
                class="form-control-plaintext"
                id="vesselType"
                value="{{ versionedVessel?.data?.spec?.vesselType }}"
              />
              <label for="vesselType">Vessel Type</label>
            </div>
          </div>
          <div class="col-md">
            <div class="form-floating">
              <input
                readonly
                class="form-control-plaintext"
                id="grt"
                value="{{
                  versionedVessel?.data?.spec?.dimensionsCapacities!.grt
                }}"
              />
              <label for="grt">GRT (ton)</label>
            </div>
          </div>
        </div>
        <div class="row g-2">
          <div class="col-md">
            <div class="form-floating">
              <input
                readonly
                class="form-control-plaintext"
                id="nrt"
                value="{{
                  versionedVessel?.data?.spec?.dimensionsCapacities!.nrt
                }}"
              />
              <label for="nrt">NRT (ton)</label>
            </div>
          </div>
          <div class="col-md">
            <div class="form-floating">
              <input
                readonly
                class="form-control-plaintext"
                id="beam"
                value="{{
                  versionedVessel?.data?.spec?.dimensionsCapacities!.beam
                }}"
              />
              <label for="beam">Beam (meter)</label>
            </div>
          </div>
          <div class="col-md">
            <div class="form-floating">
              <input
                readonly
                class="form-control-plaintext"
                id="capacity"
                value="{{
                  versionedVessel?.data?.spec?.dimensionsCapacities!.capacity
                }}"
              />
              <label for="capacity">Capacity (m<sup>3</sup>)</label>
            </div>
          </div>
        </div>
        <div class="row g-2">
          <div class="col-md">
            <div class="form-floating">
              <input
                readonly
                class="form-control-plaintext"
                id="draft"
                value="{{
                  versionedVessel?.data?.spec?.dimensionsCapacities!.draft
                }}"
              />
              <label for="draft">Draft (meter)</label>
            </div>
          </div>
          <div class="col-md">
            <div class="form-floating">
              <input
                readonly
                class="form-control-plaintext"
                id="deadWeight"
                value="{{
                  versionedVessel?.data?.spec?.dimensionsCapacities!.deadWeight
                }}"
              />
              <label for="deadWeight">Dead weight (ton)</label>
            </div>
          </div>
          <div class="col-md">
            <div class="form-floating">
              <input
                readonly
                class="form-control-plaintext"
                id="loa"
                value="{{
                  versionedVessel?.data?.spec?.dimensionsCapacities!.loa
                }}"
              />
              <label for="loa">LOA (meter)</label>
            </div>
          </div>
        </div>
        <div class="row g-2">
          <div class="col-md">
            <div class="form-floating">
              <input
                readonly
                class="form-control-plaintext"
                id="lightShip"
                value="{{
                  versionedVessel?.data?.spec?.dimensionsCapacities!.lightShip
                }}"
              />
              <label for="lightShip">Lightship (ton)</label>
            </div>
          </div>
          <div class="col-md">
            <div class="form-floating">
              <input
                readonly
                class="form-control-plaintext"
                id="email"
                value="{{ versionedVessel?.data?.spec?.email }}"
              />
              <label for="email">Email address</label>
            </div>
          </div>
          <div class="col-md">
            <div class="form-floating">
              <input
                readonly
                class="form-control-plaintext"
                id="numberOfTanks"
                value="{{
                  versionedVessel?.data?.spec?.dimensionsCapacities!.numberOfTanks
                }}"
              />
              <label for="numberOfTanks">Number Of Tanks</label>
            </div>
          </div>
        </div>
        @if (versionedVessel?.data?.spec?.ownershipOperationProtection) {
          <div class="row g-2">
            <div class="col-md">
              <div class="form-floating">
                <input
                  readonly
                  class="form-control-plaintext"
                  id="owner"
                  value="{{
                    findOrganisation(
                      versionedVessel?.data?.spec?.ownershipOperationProtection
                        .ownerId
                        ?? ''
                    )
                  }}"
                />
                <label for="owner">Owner</label>
              </div>
            </div>
            <div class="col-md">
              <div class="form-floating">
                <input
                  readonly
                  class="form-control-plaintext"
                  id="technicalOperator"
                  value="{{
                    findOrganisation(
                      versionedVessel?.data?.spec.ownershipOperationProtection
                        .technicalOperatorId
                        ?? ''
                    )
                  }}"
                />
                <label for="technicalOperator">Technical Operator</label>
              </div>
            </div>
            <div class="col-md">
              <div class="form-floating">
                <input
                  readonly
                  class="form-control-plaintext"
                  id="commercialOperator"
                  value="{{
                    findOrganisation(
                      versionedVessel?.data?.spec.ownershipOperationProtection
                        .commercialOperatorId ?? ''
                    )
                  }}"
                />
                <label for="commercialOperator">Commercial Operator</label>
              </div>
            </div>
          </div>
        }
        @if (versionedVessel?.data?.spec?.ownershipOperationProtection) {
          <div class="row g-2">
            @if (
              versionedVessel?.data?.spec.ownershipOperationProtection.builderId
            ) {
              <div class="col-md-4">
                <div class="form-floating">
                  <input
                    readonly
                    class="form-control-plaintext"
                    id="builder"
                    value="{{
                      findOrganisation(
                        versionedVessel?.data?.spec.ownershipOperationProtection
                          .builderId
                      )
                    }}"
                  />
                  <label for="owner">Builder</label>
                </div>
              </div>
            }
            @if (
              versionedVessel?.data?.spec.ownershipOperationProtection.managerId
            ) {
              <div class="col-md-4">
                <div class="form-floating">
                  <input
                    readonly
                    class="form-control-plaintext"
                    id="manager"
                    value="{{
                      findOrganisation(
                        versionedVessel?.data?.spec.ownershipOperationProtection
                          .managerId
                      )
                    }}"
                  />
                  <label for="manager">Manager</label>
                </div>
              </div>
            }
            @if (
              versionedVessel?.data?.spec.ownershipOperationProtection
                .protectionIndemnityId
            ) {
              <div class="col-md">
                <div class="form-floating">
                  <input
                    readonly
                    class="form-control-plaintext"
                    id="protectionIndemnity"
                    value="{{
                      findOrganisation(
                        versionedVessel?.data?.spec.ownershipOperationProtection
                          .protectionIndemnityId
                      )
                    }}"
                  />
                  <label for="protectionIndemnity"
                    >Protection & Indemnity</label
                  >
                </div>
              </div>
            }
          </div>
        }
        @if (versionedVessel?.data?.spec?.dryDock) {
          <div class="row g-2">
            @if (versionedVessel?.data?.spec.dryDock.lastDryDock) {
              <div class="col-md-4">
                <div class="form-floating">
                  <input
                    readonly
                    class="form-control-plaintext"
                    id="builder"
                    value="{{
                      versionedVessel?.data?.spec.dryDock.lastDryDock
                    }}"
                  />
                  <label for="owner">Last Dry Dock</label>
                </div>
              </div>
            }
            @if (versionedVessel?.data?.spec.dryDock.nextDryDock) {
              <div class="col-md">
                <div class="form-floating">
                  <input
                    readonly
                    class="form-control-plaintext"
                    id="manager"
                    value="{{
                      versionedVessel?.data?.spec.dryDock.nextDryDock
                    }}"
                  />
                  <label for="manager">Next Dry Dock</label>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>

    <div class="card shadow-sm">
      <div class="card-header">
        <a (click)="addCertificate()" class="btn btn-link text-decoration-none">
          Certificates
        </a>
        <div
          class="btn-toolbar pull-right"
          role="toolbar"
          aria-label="Toolbar with button groups"
        >
          <div class="btn-group me-2" role="group" aria-label="First group">
            <button
              type="button"
              class="btn btn-secondary"
              (click)="filteredCertificates = certificates"
            >
              All
            </button>
            <button
              type="button"
              class="btn btn-primary"
              (click)="filteredCertificates = fineCertificates"
            >
              {{ fineCertificates.length }}
            </button>
            <button
              type="button"
              class="btn btn-success"
              (click)="filteredCertificates = warningCertificates"
            >
              {{ warningCertificates.length }}
            </button>
            <button
              type="button"
              class="btn btn-warning"
              (click)="filteredCertificates = dangerCertificates"
            >
              {{ dangerCertificates.length }}
            </button>
            <button
              type="button"
              class="btn btn-danger"
              (click)="filteredCertificates = expiredCertificates"
            >
              {{ expiredCertificates.length }}
            </button>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="col-md-12 col-xs-12">
          <ag-grid-angular
            class="ag-theme-alpine"
            [gridOptions]="certificateGridOptions"
            (gridReady)="gridSetting($event)"
            [columnDefs]="certificateColumnDefs"
            [rowData]="filteredCertificates"
            [domLayout]="'autoHeight'"
            [pagination]="true"
            [paginationPageSize]="10"
            [paginationPageSizeSelector]="[10, 20, 30]"
            [enableCellTextSelection]="true"
          >
          </ag-grid-angular>
        </div>
      </div>
    </div>
    <div class="card shadow-sm">
      @if (q88FileId) {
        <div>
          <app-material-pdf-viewer [title]="'Q88'" [fileId]="q88FileId">
          </app-material-pdf-viewer>
        </div>
      }
    </div>
  </div>
  <div class="col-md-6 container">
    @if (volumes !== undefined) {
      <div class="card shadow-sm">
        <div class="card-header">
          <a
            class="btn btn-link text-decoration-none"
            [routerLink]="['/vessels/voyage', selectedVoyage.id]"
          >
            Last Voyage
          </a>
        </div>
        <div class="card-body">
          <table class="table table-sm table-striped table-bordered">
            <thead>
              <tr>
                <td class="bg-info text-center">Items</td>
                <td class="bg-primary text-center">Loading</td>
                <td class="bg-success text-center">Discharging</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="text-center">No. Of Ports</td>
                <td class="text-center">
                  {{ volumes.noLoadingPorts | number }}
                </td>
                <td>{{ volumes.noDischargePorts | number }}</td>
              </tr>
              <tr>
                <td class="text-center">Ports</td>
                <td class="text-center">
                  @for (p of volumes.loadPorts; track $index) {
                    <span>{{ p }}</span>
                    <br />
                  }
                </td>
                <td class="text-center">
                  @for (p of volumes.dischargePorts; track $index) {
                    <span>{{ p }}</span>
                    <br />
                  }
                </td>
              </tr>
              <tr>
                <td class="text-center">Weight (Ton)</td>
                <td class="text-center">
                  <span
                    >Real: <br />
                    @for (p of volumes.loadingRealWeight; track $index) {
                      {{ p["product"] }}: {{ p["grossWeight"] | number }}<br />
                    }
                  </span>
                  <span
                    >Revise: <br />
                    @for (p of volumes.loadingReviseWeight; track $index) {
                      {{ p["product"] }}: {{ p["grossWeight"] | number }}<br />
                    }
                  </span>
                </td>
                <td class="text-center">
                  @for (p of volumes.dischargeWeight; track $index) {
                    {{ p["product"] }}: {{ p["weight"] | number }}<br />
                  }
                </td>
              </tr>
              <tr>
                <td class="text-center">Berth Time (Hours)</td>
                <td class="text-center">
                  {{ volumes.loadingBerthTime | number }}
                </td>
                <td>{{ volumes.dischargeBerthTime | number }}</td>
              </tr>
              <tr>
                <td class="text-center">Laytime (Hours)</td>
                <td class="text-center">
                  {{ volumes.loadingLaytime | number }}
                </td>
                <td>{{ volumes.dischargeLaytime | number }}</td>
              </tr>
              <tr>
                <td class="text-center">Total Real Weight</td>
                <td class="text-center">{{ volumes.allLoading | number }}</td>
                <td class="text-center">
                  {{ volumes.allDischarging | number }}
                </td>
              </tr>
            </tbody>
            <thead>
              <tr>
                <td colspan="3" class="text-center bg-warning text-center">
                  Differences
                </td>
              </tr>
              <tr>
                <td class="text-center" colspan="2">
                  Time between Loading Discharge (Days)
                </td>
                <td class="text-center">Weight Difference (Ton)</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="text-center" colspan="2">
                  {{ volumes.timeBetweenLoadingDis }}
                </td>
                <td>
                  @for (d of volumes.diff; track $index) {
                    <span>{{ d["product"] }}: {{ d["diff"] | number }}</span
                    ><br />
                  }
                </td>
              </tr>
              <tr>
                <td class="text-center" colspan="2">Total Difference</td>
                <td class="text-center">{{ volumes.allDiff | number }}</td>
              </tr>
            </tbody>
          </table>
          <span class="info"
            >Weight differences are between Real BL and primary discharges</span
          >
        </div>
      </div>
    }

    <div class="card">
      <div class="card-header">
        <b>Audits</b>
      </div>
      @if (versionedVessel?.data) {
        <div class="card-body">
          <app-vessel-internal-audits
            [vesselImo]="$safeNavigationMigration(versionedVessel?.data?.imo)"
          />
        </div>
      }
    </div>

    @if (versionedVessel?.data) {
      <div class="card mt-3">
        <div class="card-header">
          <a
            class="btn btn-link text-decoration-none"
            [routerLink]="[
              '/vessels/vessels-manual',
              $safeNavigationMigration(versionedVessel?.data?.imo),
            ]"
          >
            Manuals & Drawings
          </a>
        </div>
        <div class="card-body">
          <table class="table table-sm">
            <thead>
              <tr>
                <th>Name</th>
                <th>Type</th>
              </tr>
            </thead>
            <tbody>
              @for (m of versionedVessel.data.spec?.manuals; track $index) {
                <tr>
                  <td class="text-wrap">
                    <a
                      class="btn btn-link text-decoration-none text-capitalize"
                      (click)="downloadDocument(m.fileId, 'Manual')"
                    >
                      {{ m.name }}
                    </a>
                  </td>
                  <td>{{ m.manualType }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    }

    <div class="card" *appHideIfNotInRole="['vessels-crew-viewer']">
      <div class="card-header">
        <a
          class="btn btn-link text-decoration-none"
          [routerLink]="['/vessels/fleet-personnel-management']"
        >
          On Board Crews
        </a>
      </div>
      <div class="card-body">
        <div class="col-md-12 col-xs-12">
          <ag-grid-angular
            class="ag-theme-alpine"
            [gridOptions]="crewGridOptions"
            (gridReady)="gridSetting($event)"
            (firstDataRendered)="restoreGridState($event)"
            (paginationChanged)="saveGridState($event)"
            (sortChanged)="saveGridState($event)"
            [columnDefs]="crewColumnDefs"
            [rowData]="onBoardCrews"
            [domLayout]="'autoHeight'"
            [pagination]="true"
            [paginationPageSize]="10"
            [paginationPageSizeSelector]="[10, 20, 30]"
            [enableCellTextSelection]="true">
          </ag-grid-angular>
        </div>
      </div>
    </div>
    <div class="card shadow-sm">
      @if (formCFileId) {
        <div>
          <app-material-pdf-viewer
            [title]="'Form C'"
            [fileId]="formCFileId">
          </app-material-pdf-viewer>
        </div>
      }
    </div>
  </div>
</div>
